export const enum ToastType {
  Error,
  Success,
}
